import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

export const APP_HEADER_ACTION_SLOT_ID = 'app-header-action-slot';

/**
 * A screen's own action in the AppHeader's right slot (e.g. Edit, Share),
 * rendered from the screen itself:
 *
 *   <AppHeaderAction><button …>Edit</button></AppHeaderAction>
 *
 * Renders nothing on the web or at a tab root (no AppHeader there), and
 * nothing during SSR: the slot only exists once AppTopBar has mounted.
 */
const AppHeaderAction = ({ children }) => {
  const [slot, setSlot] = useState(null);

  useEffect(() => {
    setSlot(document.getElementById(APP_HEADER_ACTION_SLOT_ID));
  }, []);

  return slot ? createPortal(children, slot) : null;
};

AppHeaderAction.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppHeaderAction;
